import React from "react";
import { Check, CheckAll } from "react-bootstrap-icons";
import { Spinner } from "react-bootstrap";
import { MessageStatusIndicatorProps } from "./message-status-indicator.props";

const formatDateTime = (timestamp: number): string => {
  return new Date(timestamp).toLocaleString("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const buildTooltip = (mainDate: number, updatedAt?: number): string => {
  let tooltip = formatDateTime(mainDate);
  if (updatedAt && updatedAt !== mainDate) {
    tooltip += `\nИзменено: ${formatDateTime(updatedAt)}`;
  }
  return tooltip;
};

export const MessageStatusIndicator = ({
  msg,
  isUserMsg,
  isSelected,
  loadingMessage,
  forceHoverStyle = false,
  isVoiceMessage = false,
  hasFiles = false,
}: MessageStatusIndicatorProps) => {
  const textColor = forceHoverStyle
    ? "#fff"
    : isSelected
    ? "#fff"
    : isUserMsg
    ? "#6c757d"
    : "#e0e0e0";

  return (
    <div
      style={{
        position: "absolute",
        bottom: isVoiceMessage ? 1 : forceHoverStyle ? 5 : hasFiles ? 5 : 2,
        right: forceHoverStyle ? !msg.err ? 4 : 13 : !msg.err ? isVoiceMessage ? 10 : 6 : 18,
        display: "flex",
        alignItems: "center",
        gap: 4,
        fontSize: "10px",
        userSelect: "none",
        color: textColor,
        backgroundColor: forceHoverStyle ? "#6c757da3" : "transparent",
        padding: forceHoverStyle ? "1px 4px" : "0",
        borderRadius: "16px",
        zIndex: 1,
      }}
    >
      {msg.updatedAt && <span>изменено</span>}
      <span>
        {new Date(msg.createdAt).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })}
      </span>

      {loadingMessage ? (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          style={{ width: "12px", height: "12px" }}
        />
      ) : (
        isUserMsg && (
          <>
            {!msg.delivedAt && !msg.readedAt && !msg.err && (
              <Check size={12} color={textColor} />
            )}
            {msg.delivedAt && !msg.readedAt && (
              <CheckAll
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={buildTooltip(msg.delivedAt, msg.updatedAt)}
                size={12}
                color={textColor}
              />
            )}
            {msg.readedAt && (
              <CheckAll
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={buildTooltip(msg.readedAt, msg.updatedAt)}
                size={12}
                color={isSelected ? "#fff" : "#007bff"}
              />
            )}
          </>
        )
      )}
    </div>
  );
};
